<template>

	<header>
		<div v-if="$gstate.getPSA()" class="alert alert-timer text-center">
			<small>{{ $gstate.getPSA() }}</small>
		</div>
		<div class="container-fluid">
					
			<nav class="navbar sticky-top navbar-expand-sm navbar-light bg-faded">
				<div class="container">
					<!-- Brand -->
					<div class="navbar-brand">
						<a :title="$gstate.getMerchantName()" @mouseover="getHomeUrl()" :alt="$gstate.getMerchantName()" id="navbar-logo" v-bind:href="homeUrl"></a>
					</div>
					
					
					<div v-if="!$gstate.isProd()">{{ $gstate.getEnv() }} {{ $gstate.getVersion() }}</div>
					
				</div><!--container-->
			</nav>

		</div>
	</header>

</template>

<script>
export default {
	data() {
		return {
			tickerCoins : {},
			componentKey : 0,
			homeUrl: '',
		}
	},
	mounted() {
		//this.getTicker();
	},
	methods: {
		getHomeUrl(){
			this.homeUrl = this.$gstate.getSiteURL();
		},
		getTicker(){
			var urlstr = "/pubapi/ticker/merchant";
			this.axios.get(urlstr)
				.then(response => {
					
					var supportedCoins = this.$gstate.getSupportedCoins();
					var supportedFiatCurrency = this.$gstate.getSupportedFiatCurrencies();
					if(response.data != null){
						for(var i = 0; i < Object.keys(response.data).length; i++){
							
							if(supportedCoins[response.data[i].cryptoCurrency] != undefined && supportedFiatCurrency[response.data[i].fiatCurrency] != undefined && response.data[i].fiatCurrency == this.$gstate.getActiveFiatCurrency()){
								this.tickerCoins[response.data[i].cryptoCurrency] = { 
									fiatAmount: response.data[i].fiatAmount,
									fiatCurrency : response.data[i].fiatCurrency
								}
							}
						}

						this.componentKey++;
					}
					
				})
				.catch(error => {
					this.$gstate.log(error);
				});
		}
	},
}
</script>

